/**
 * 轻量 Markdown 渲染（自 AiChatWidget 抽取为共享纯函数，W9 组件化重构）。
 * 消费方：AI 聊天气泡（think/正式回复/流式）、空间问答 QaAnswerBubble、文件 AI 摘要弹窗。
 * 支持：代码块、行内代码、粗体、斜体、链接、列表、标题、换行。
 * ⚠️ XSS 防线：输出必须经 v-safe-html（DOMPurify 消毒）挂载，禁止直接 v-html。
 * 样式约定：产物类名（md-h2/code-block/md-link 等）由 main.css 的 .markdown-body 全局规则承载。
 */

/**
 * 将Markdown文本转换为安全的HTML
 * 支持：代码块、行内代码、粗体、斜体、链接、列表、换行
 */
export function renderMarkdown(text) {
  if (!text) return ''
  let html = text
    // 转义HTML特殊字符（防XSS）
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  // 代码块 ```lang\n...\n```
  html = html.replace(/```(\w*)\n([\s\S]*?)```/g, (_, lang, code) => {
    return `<pre class="code-block"><code class="language-${lang || 'text'}">${code.trim()}</code></pre>`
  })

  // 行内代码 `...`
  html = html.replace(/`([^`]+)`/g, '<code class="inline-code">$1</code>')

  // 粗体 **...**
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')

  // 斜体 *...*
  html = html.replace(/\*(.+?)\*/g, '<em>$1</em>')

  // 链接 [text](url)
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" class="md-link">$1</a>')

  // 无序列表 - item（连续行）
  html = html.replace(/^- (.+)$/gm, '<li>$1</li>')
  html = html.replace(/(<li>[\s\S]*?<\/li>)/g, '<ul class="md-list">$1</ul>')
  // 合并相邻ul
  html = html.replace(/<\/ul>\s*<ul class="md-list">/g, '')

  // 有序列表 1. item
  html = html.replace(/^\d+\. (.+)$/gm, '<li>$1</li>')

  // 标题 ### h3, ## h2, # h1
  html = html.replace(/^### (.+)$/gm, '<h4 class="md-h4">$1</h4>')
  html = html.replace(/^## (.+)$/gm, '<h3 class="md-h3">$1</h3>')
  html = html.replace(/^# (.+)$/gm, '<h2 class="md-h2">$1</h2>')

  // 换行
  html = html.replace(/\n/g, '<br/>')

  return html
}
